'use client';

/**
 * Opens the OneTrust Preference Center.
 * Single entry point used by both the consent banner and the footer link.
 * Dispatches a custom event so the banner hook can dismiss itself.
 */
export const openPreferenceCenter = (): void => {
  // Notify the consent banner to dismiss
  globalThis.dispatchEvent(new CustomEvent('consent:open-preferences'));

  // Ensure SDK wrapper is visible (Close() may have hidden it)
  const sdkWrapper = document.querySelector('#onetrust-consent-sdk');
  if (sdkWrapper instanceof HTMLElement) {
    sdkWrapper.style.display = '';
  }

  globalThis.OneTrust?.ToggleInfoDisplay();
};
